import React, { useContext, useEffect, useState } from "react";
import { Button, Checkbox, DatePicker, Input, Select, Table, Tag } from "antd";
import axiosInstance from "../common/api";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ExportOutlined, FileExcelOutlined, PlusOutlined, WarningTwoTone } from "@ant-design/icons";
import dayjs from "dayjs";
import { date2locale, filterOption } from "../common/common";
import Toolbar from "../common/Toolbar";
import { UserInfoContext } from "../FetchUserInfo";
import FilterRow from "../components/filter/FilterRow";
import DebounceSelect from "../common/DebounceSelect";

export default function ({
    fetchFunction,
    addAction,
    columns = [],
    rowKey = "id",
    defaultPage = 0,
    defaultPageSize = 10,
    enableSelection = true,
    filterItems = [],
    rowSelectionType = "checkbox",
    toolbarProps,
    children,
    ...props
}) {
    const [loading, setLoading] = useState(true);
    const user = useContext(UserInfoContext);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [result, setResult] = useState({});
    const page = searchParams.get("page") ?? defaultPage;
    const pageSize = searchParams.get("pageSize") ?? defaultPageSize;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const location = useLocation();
    const [filtersValue, setFiltersValue] = useState([]);

    const fetchData = () => {
        setLoading(true);
        setSelectedRowKeys([]);
        const params = [...searchParams.entries()]
            .map(([k, v]) => [k.replace("filter.", ""), v])
            .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
        fetchFunction({ ...params, page, pageSize }).then(({ data }) => {
            setResult(data);
            setLoading(false);
        });
    };

    useEffect(() => {
        const val = [...searchParams.entries()]
            .filter(([k, _]) => k.startsWith("filter."))
            .map(([k, v]) => ({ name: k.replace("filter.", ""), value: v }));
        setFiltersValue(val);
        fetchData();
    }, [searchParams]);

    const onFilterChange = (filters) => {
        [...searchParams.keys()].forEach((k) => searchParams.delete(k));
        filters
            .filter((x) => !!x.value)
            .forEach((x) => searchParams.set("filter." + x.name, x.value));
        setSearchParams(searchParams, { replace: true });
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 16 }}>
            {children?.(fetchData)}
            <FilterRow onChange={onFilterChange} value={filtersValue} items={filterItems} />
            <div>
                <Toolbar
                    selectedKeys={selectedRowKeys}
                    {...(typeof toolbarProps === "function"
                        ? toolbarProps(fetchData)
                        : toolbarProps)}
                />
                <Table
                    columns={columns}
                    tableLayout={"fixed"}
                    size="small"
                    rowKey={rowKey}
                    dataSource={result?.data?.map((x) => ({ ...x, key: x.id }))}
                    loading={loading}
                    onChange={(pagin, filters, sorter) => {
                        searchParams.set("page", pagin.current - 1);
                        searchParams.set("pageSize", pagin.pageSize);
                        setSearchParams(searchParams);
                    }}

                    onRow={(record) => ({
                        onClick: () => setSelectedRowKeys([record.id]),
                    })}
                    rowSelection={
                        enableSelection && {
                            selectedRowKeys,
                            onChange: setSelectedRowKeys,
                            type: rowSelectionType,
                        }
                    }
                    pagination={{
                        current: Number(page) + 1,
                        showTotal: (total) => "Totale: " + total,
                        pageSize: pageSize,
                        total: result.count ?? 0,
                    }}
                />
            </div>
        </div>
    );
}
